import { PayloadAction } from '../../../../../store.model';
import { dateTransformRows } from '../function/date-transform-rows.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../main.action';
import { MainState } from '../main.state';

import { ExpandRow, ExpandRowResult } from './expand-row.action';

export function expandRowReducer(
    state: MainState,
    _: PayloadAction<ActionType.WP_MAIN__EXPAND_ROW, ExpandRow>,
): MainState {
    return {
        ...state,
    };
}

export function expandRowResultReducer(
    state: MainState,
    action: PayloadAction<
        ActionType.WP_MAIN__EXPAND_ROW_RESULT,
        ExpandRowResult
    >,
): MainState {
    try {
        const nextRows = sortRows(
            action.payload.rows,
            state.sortOptions,
            state.table,
            state.config,
        );

        dateTransformRows(nextRows);

        return {
            ...state,
            otherRows: [
                {
                    rowId: action.payload.rowId,
                    rows: nextRows,
                },
            ],
        };
    } catch (err) {
        console.log(err);

        return {
            ...state,
        };
    }
}
